export const ACTION_TYPE = 'actionType';
export const FLOW_ID = 'flowId';